import * as XLSX from 'xlsx';
import { ProjectBudgetDTO, ProjectsRycApiClient } from '../Api/ApiServer';
import { useApi } from '../Api/useApi';
export const ImportBudget = async (files: FileList | null, importedCallback: (items: ProjectBudgetDTO[]) => void) => {   

    if (files === null)
        return false;
    const file = files[0];
    const reader = new FileReader();
    // let data_output = new ImportJsonModel();

    // let newId = 0;
    // let options = parseOptions(opt);

    const parseOrderNumber = (orderNumber: string) => {
        if (orderNumber && orderNumber.includes('.')) {
            return orderNumber.split('.')[0];
        }
        else return orderNumber;
    };

    const parseOrderNumberSecond = (orderNumber: string) => {
        if (orderNumber && orderNumber.includes('.')) {
            return orderNumber.split('.')[1];
        }
        else return "";
    };

    reader.onload = async (e: any) => {
        const data = new Uint8Array(e.target.result);
        try {

            const workbook = XLSX.read(data, { type: 'array' });
            console.log(workbook.Sheets[workbook.SheetNames[0]]["A1"]);
            const lastCell = workbook.Sheets[workbook.SheetNames[0]]['!ref'];
            console.log(lastCell);
            const items: ProjectBudgetDTO[] = [];
            if (lastCell) {
                const lastCellIndex = lastCell.split(':')[1];
                console.log(lastCellIndex.substring(1));
                let orderNumberHolder = '';
                let itemCodeHolder = '';

                let objectName = '';
                let partName = '';
                for (let i = 2; i < Number(lastCellIndex.replace(/\D/g, "")); i += 1) {
                    let firstCol = workbook.Sheets[workbook.SheetNames[0]][`A${i}`];
                    let secondColumn = workbook.Sheets[workbook.SheetNames[0]][`B${i}`];

                    const orderNumber = firstCol ? firstCol.v : orderNumberHolder;
                    orderNumberHolder = orderNumber;

                    const itemCode = secondColumn ? secondColumn.v : itemCodeHolder;
                    itemCodeHolder = itemCode;

                    const itemName = workbook.Sheets[workbook.SheetNames[0]][`C${i}`]?.v;

                    if (!secondColumn){
                        if (firstCol) {
                            if ((firstCol.v + '').includes('.')) {
                                partName = itemName;
                            }
                            else objectName = itemName;
                        }
                        continue;
                    }


                    const amount = workbook.Sheets[workbook.SheetNames[0]][`F${i}`]?.v ?? 0;
                    const unitPrice = workbook.Sheets[workbook.SheetNames[0]][`G${i}`]?.v ?? 0;

                    console.log(orderNumber, itemCode, itemName, amount, unitPrice);

                    if (!itemName || itemName === '') {
                        break;
                    }
                    items.push(new ProjectBudgetDTO({ orderNumber: parseOrderNumber(orderNumber + ''), orderNumberSecond: parseOrderNumberSecond(orderNumber + ''), itemCode: itemCode + '', itemName: itemName ?? '', amount: amount ?? 0, unitPrice: unitPrice ?? 0, objectName: objectName, partName: partName }));
                }
                importedCallback(items);
            }

        }
        catch (error) {
            console.error(error);
        }
    }
    reader.readAsArrayBuffer(file);
}